
/** Modes the Quests Closed page can be viewed by. */
export enum QuestClosedViewByMode {
  All = 'all',
  Student = 'student',
  Group = 'classroomGroup',
}
